import React, { Component } from "react";
import { useEffect } from "react";
import { useState } from "react";
import Nestable from "react-nestable";
import { AxiosPost } from "../../../../context/UserContext";
import { pushNotify } from "../../../../services/NotifyService";
import CustomizedTreeView from "./CustomizedTreeView";
import "./style.css"

const Budgeting = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [treeItems, setTreeItems] = useState([]);
    const [actualSpent, setActualSpent] = useState([]);
    const [spentData, setSpentData] = useState([]);

    const getSpent = (id) => {
        let sum = 0
        for (let index = 0; index < spentData.length; index++) {
            if (spentData[index].category_id_desc != null && spentData[index].category_id_desc.includes(id) && props.ids.includes(spentData[index].transaction_id)) sum += parseInt(spentData[index].amount)
        }
        return sum
    }

    const getApprSpent = (id) => {
        let sum = 0
        for (let index = 0; index < spentData.length; index++) {
            if (spentData[index].category_id_desc != null && spentData[index].category_id_desc.includes(id) && spentData[index].status == "Approved" && props.ids.includes(spentData[index].transaction_id)) sum += parseInt(spentData[index].amount)
        }
        return sum
    }

    const renderItem = ({ item, collapseIcon, handler }) => {
        return (
            <div>
                {handler}
                {collapseIcon}
                {item.text}
                <span style={{ "marginLeft": "15px" }}>
                    Total Amount: {Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(getSpent(item.id))}
                </span>
                <span style={{ "marginLeft": "15px" }}>
                    Approved Amount: {Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(getApprSpent(item.id))}
                </span>
            </div>
        );
    };

    const fetchCategories = async () => {
        try {
            setIsLoading(true);
            const data = await AxiosPost('fetch_filter_categories.php');
            console.log(data)
            if (data.success) {
                setTreeItems(data.category)
                setActualSpent(data.actual_spent)
                setSpentData(data.spent_data)
            }
            else {
                pushNotify("error", "Error", data.error)
            }
        } catch {
            pushNotify("error", "Error", "Server Error!")
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        fetchCategories()
    }, [])

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="card" style={{ "height": "fit-content" }}>
                    <div className="card-header border-0 pb-0">
                        <h4 className="card-title">Budgets</h4>
                    </div>
                    <div className="card-body">
                        <CustomizedTreeView getApprSpent={getApprSpent} getSpent={getSpent} items={treeItems}></CustomizedTreeView>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Budgeting;
